import { CheckGroup, Area, Radio, Section } from "./fields";

export const emptyNeeds = { help_areas: [], mobility: "", transfer_assist: "", memory: "", description: "" };

export const HELP_AREAS = [
  "Bathing & personal hygiene", "Dressing", "Meal preparation", "Eating",
  "Housekeeping & laundry", "Shopping & errands", "Rides / transportation",
  "Medication reminders", "Moving around / walking", "Getting in & out of bed or a chair",
  "Toileting", "Companionship", "Supervision & safety", "Managing money / bills", "Memory support",
];

export default function NeedsForm({ data, onChange }) {
  const set = (k) => (e) => onChange({ ...data, [k]: e.target.value });
  const setR = (k) => (v) => onChange({ ...data, [k]: v });
  return (
    <div className="space-y-6" data-testid="needs-form">
      <Section title="What help is needed?" desc="Check everything that applies — even a rough idea helps.">
        <div className="md:col-span-2">
          <CheckGroup label="The client needs help with…" options={HELP_AREAS}
            values={data.help_areas} onChange={setR("help_areas")} tidPrefix="needs-area" />
        </div>
      </Section>
      <Section title="Mobility & physicality" desc="This helps us send the right caregiver with the right training — there's a big difference between someone who needs full physical care and someone who just needs help making lunch.">
        <Radio label="How does the client usually move around?" options={["Walks independently", "Walks with a cane or walker", "Uses a wheelchair", "Mostly or completely bedridden"]}
          value={data.mobility} onChange={setR("mobility")} tid="needs-mobility" />
        <Radio label="How much physical help do they need to move, stand, or transfer?" options={["No physical help needed", "One-person assist", "Two-person assist", "Not sure"]}
          value={data.transfer_assist} onChange={setR("transfer_assist")} tid="needs-transfer" />
        <Radio label="Any memory problems?" options={["No memory problems", "Some forgetfulness", "Dementia or significant memory loss"]}
          value={data.memory} onChange={setR("memory")} tid="needs-memory" />
      </Section>
      <Section title="In your own words">
        <div className="md:col-span-2">
          <Area label="Anything else that would help us understand the situation — a typical day, recent changes, worries" tid="needs-description"
            value={data.description} onChange={set("description")} rows={4}
            placeholder="e.g. Mom gets around with a walker and is mostly independent — she just stopped cooking and needs meals and company. OR: Dad is bedridden and needs full hands-on help with everything." />
        </div>
      </Section>
    </div>
  );
}
